import { Modal } from 'react-bootstrap';

import optainLogoImg from 'src/assets/icons/logo-b/optain.png';

import CustomModal from 'src/components/custom_components/CustomModal/CustomModal';

import useUiTranslation from 'src/hooks/useUiTranslation';

interface LoginContainerProps {
  children: React.ReactNode;
}

const LoginContainer = ({ children }: LoginContainerProps) => {
  const { tPages } = useUiTranslation();

  return (
    <CustomModal show centered scrollable={false} className="bg-solid">
      <Modal.Header closeButton={false}>
        <Modal.Title>
          <img
            src={optainLogoImg}
            alt="Logo"
            width={50}
            className="object-fit-contain"
          />
          <span className="ms-2">{tPages('loginLogout.title')}</span>
        </Modal.Title>
      </Modal.Header>
      {children}
    </CustomModal>
  );
};

export default LoginContainer;
